'use client'

import Link from 'next/link'
import { useEffect, useState } from 'react'
import { SignedIn, SignedOut } from '@clerk/nextjs'
import { BrandLockup } from './atoms'

export function Nav() {
  const [scrolled, setScrolled] = useState(false)
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])
  return (
    <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-inner">
        <a href="#top" style={{ display: 'flex', alignItems: 'center' }} aria-label="ribbit home">
          <BrandLockup markSize={26} wordSize={19} />
        </a>
        <div className="nav-links">
          <a href="#why">Why ribbit</a>
          <a href="#bookkeeping">Bookkeeping</a>
          <a href="#ai">AI assistant</a>
          <a href="#planning">Planning</a>
          <a href="#pricing">Pricing</a>
        </div>
        <div className="nav-cta">
          <SignedOut>
            <Link className="btn btn-ghost" href="/sign-in">Sign in</Link>
            <Link className="btn btn-primary" href="/sign-up">Get started</Link>
          </SignedOut>
          <SignedIn>
            <Link className="btn btn-primary" href="/dashboard">Go to dashboard</Link>
          </SignedIn>
        </div>
      </div>
    </nav>
  )
}
